import { LocalLocationOptionConfiguration } from './local-location-option-configuration.model';
import { ChangeData } from 'ngx-intl-tel-input';

export class LocalLocationProfileConfiguration {

  public id: string;
  public name: string;
  public checkinAllowed: boolean;
  public checkoutAllowed: boolean;
  public supportPhoneNumber: ChangeData;
  public options: LocalLocationOptionConfiguration[] = [];

  static fromDto(data: any): LocalLocationProfileConfiguration {
    const profile = new LocalLocationProfileConfiguration();

    if (!data) {
      return null;
    }

    profile.id                  = data.id;
    profile.name                = data.name;
    profile.checkinAllowed      = data.checkin_allowed;
    profile.checkoutAllowed     = data.checkout_allowed;
    profile.options             = data.options ? data.options.map(option => LocalLocationOptionConfiguration.fromDto(option)) : [];
    profile.supportPhoneNumber  = {
      number: data.support_phone_number,
      internationalNumber: data.support_phone_number,
      nationalNumber: data.support_phone_number,
      e164Number: data.support_phone_number,
      countryCode: data.support_phone_number,
      dialCode: data.support_phone_number
    };

    return profile;
  }

  static toDto(c: LocalLocationProfileConfiguration): any {
    if (!c) {
      return null;
    }

    return {
      id: c.id,
      name: c.name,
      checkin_allowed: c.checkinAllowed,
      checkout_allowed: c.checkoutAllowed,
      support_phone_number: c.supportPhoneNumber.e164Number,
      options: c.options ? c.options.map(option => LocalLocationOptionConfiguration.toDto(option)) : []
    };
  }
}
